module.exports = __webpack_public_path__ + "static/media/blueprint.20f0e49a.png";